/**
 * Created by mabiao on 2017/11/10.
 */
import Vue from 'vue';
import {getOsVersion} from './utils.js';

let env = process.env.NODE_ENV;
try {
	window.BJ_REPORT.init({
		id: 11, //project_code
		uin: 'yiqiwen-app', //用户标识
		url: '//error.youjyi.cn/api/errrorlog/receive', //上报url
		random: 5, //抽样上报
		offlineLog: false, //是否离线上报
		onReport: function (id, errObj) {
			//上报回调
		}
	});
} catch (e) {
	console.log(e);
}

Vue.config.errorHandler = function (err, vm, info) {
	let {message, name, script, line, column, stack} = err;
	script = script !== undefined ? script : '';
	line = line !== undefined ? line : 0;
	column = column !== undefined ? line : 0;
	let stackStr =
		(stack && stack.toString()) ||
		(name !== undefined &&
			message !== undefined &&
			name !== 'undefined' &&
			message !== 'undefined' &&
			`${name}:${message}`) ||
		err;
	console.log('stackStr:' + stackStr);

	// 生产环境才上报
	if (env !== 'development') {
		try {
			let platform = localStorage.getItem('platform');
			let osVersion = getOsVersion();
			if (osVersion.indexOf('Android') > -1 && Number(osVersion.slice(7, 8)) < 6) {
				return;
			}
			BJ_REPORT.report({
				msg: stackStr,
				from:
					window.location.href +
					(window.location.href.indexOf('?') ? '&' : '?') +
					`_platform=${platform}`,
				target: script,
				rowNum: line,
				colNum: column
			});
		} catch (e) {
			console.log(e);
		}
	}
};



// WEBPACK FOOTER //
// ./src/common/js/bj_report.js